module.exports = __webpack_public_path__ + "media/icons/volume_down-934a18c9.svg";